import React, { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import config from '../config/config';
import { getToken } from '../utils/auth';

const SimpleChat = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [connected, setConnected] = useState(false);
  const [error, setError] = useState('');
  const socketRef = useRef(null);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setError('Чат ашиглахын тулд нэвтэрнэ үү.');
      return;
    }
    const socket = io(config.socketUrl, { transports: ['websocket'], auth: { token } });
    socketRef.current = socket;

    socket.on('connect', () => {
      setConnected(true);
      setError('');
      socket.emit('chat:subscribe', { token });
    });
    socket.on('disconnect', () => {
      setConnected(false);
    });
    socket.on('chat:message', (msg) => {
      setMessages(prev => [...prev, msg]);
    });
    socket.on('chat:conversation:selected', ({ messages: history }) => {
      setMessages(history || []);
    });
    socket.on('chat:error', (payload) => {
      setError(payload?.message || 'Чат ачааллах үед алдаа гарлаа');
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const sendMessage = e => {
    e.preventDefault();
    if (!input.trim() || !connected) return;
    socketRef.current?.emit('chat:message', { text: input });
    setInput('');
  };

  return (
    <div className="simple-chat-root">
      <h2>Чат</h2>
      {!connected && error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
      <div className="simple-chat-box">
        {messages.map((msg, i) => (
          <div key={msg.id || i} className={msg.role === 'user' ? 'simple-chat-msg user' : 'simple-chat-msg admin'}>
            <span className="simple-chat-bubble">{msg.text}</span>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <form className="simple-chat-form" onSubmit={sendMessage}>
        <input value={input} onChange={e => setInput(e.target.value)} placeholder="Мессеж бичих..." disabled={!connected} />
        <button type="submit" disabled={!connected || !input.trim()}>Илгээх</button>
      </form>
      <style>{`
        .simple-chat-root {
          max-width: 400px;
          margin: 0 auto;
        }
        .simple-chat-box {
          border: 1px solid #eee;
          border-radius: 10px;
          height: 200px;
          overflow-y: auto;
          margin-bottom: 10px;
          padding: 10px;
          background: #fafbfc;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .simple-chat-msg {
          display: flex;
          margin: 2px 0;
        }
        .simple-chat-msg.user {
          justify-content: flex-end;
        }
        .simple-chat-msg.admin {
          justify-content: flex-start;
        }
        .simple-chat-bubble {
          background: #e0f7fa;
          color: #111;
          border-radius: 12px;
          padding: 6px 14px;
          display: inline-block;
          max-width: 80%;
          word-break: break-word;
        }
        .simple-chat-msg.admin .simple-chat-bubble {
          background: #f1f8e9;
        }
        .simple-chat-form {
          display: flex;
          gap: 8px;
        }
        .simple-chat-form input {
          flex: 1;
          padding: 10px;
          border-radius: 7px;
          border: 1px solid #ddd;
          font-size: 1em;
        }
        .simple-chat-form button {
          padding: 10px 18px;
          border-radius: 7px;
          background: #2563eb;
          color: #fff;
          font-weight: 600;
          border: none;
          font-size: 1em;
          cursor: pointer;
          transition: background 0.18s;
        }
        .simple-chat-form button:disabled {
          background: #b6c3d1;
          cursor: not-allowed;
        }
        @media (max-width: 600px) {
          .simple-chat-root {
            max-width: 100%;
          }
          .simple-chat-box {
            height: 140px;
            padding: 6px;
          }
          .simple-chat-form input {
            padding: 8px;
          }
          .simple-chat-form button {
            padding: 8px 10px;
          }
        }
      `}</style>
    </div>
  );
};

export default SimpleChat;
